import React, { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/CustomerStyle.css';
import { Nav, Navbar, Offcanvas, Container, Image, Row, Col, Button, NavDropdown, Stack } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from '../../../images/logo1.png';
import notify from '../../../images/notify.png';
import person from "../../../images/person.png";
import { useSelector, useDispatch} from 'react-redux';
import { setCustomerLogout, setCustomerLogoutUrl, setCustomerNotification } from '../../../reducers/User/action';
import Swal from "sweetalert2";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import HomeIcon from '@mui/icons-material/Home';
import LoginIcon from '@mui/icons-material/Login';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import * as signalR from "@microsoft/signalr";
import { getCustomerNotificationList, postCustomerNotificationView } from '../../../Service';
import { requestNotificationPermission, showNotification } from '../../Reusable';
import { initCustomerConnection } from '../../Reusable/signalRService';

export default function CustomerHeader(props){

    const params = useLocation();
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => setShow(true);
    let urlPathName = params.pathname;

    const navigate = useNavigate();
    const dispatch=useDispatch();

    let loggedUser = useSelector(store => store.user['customeruser']);
    let apiToken = useSelector(store => store.user['customertoken']);
    let customerNotification = useSelector(store => store.user.customerNotification);
    let webNotificationStatus = useSelector(store => store.user.webNotificationStatus);

    const connectionRef = useRef(null);

    // useEffect(() => {
    //     if ( loggedUser && loggedUser.id ) {
    //         getCustomerNotificationList().then(res => notificationResponseHandle(res));
    //     }

    //     // requestNotificationPermission();
    // }, []);

    // const notificationResponseHandle = ( res ) => {

    //     if ( res.data.statusCode === 200 ) {
    //         let notification = {'count' : res.data.isCustomerViewedCount, 'list' : res.data.bookingList};

    //         dispatch(setCustomerNotification(notification));
    //     } 

    // }

    // useEffect(() => {
    //     if ( loggedUser && loggedUser.id ) {
    //         let userId = 'CustomerNotification'+loggedUser.id;
    //         const connection = new signalR.HubConnectionBuilder()
    //             .withUrl("https://unextdev.datanetiix.com/notificationHub")
    //             .withAutomaticReconnect()
    //             .build();
        
    //         connection
    //             .start()
    //             .then()
    //             .catch((err) => console.error("test eerr:", err));
        
    //         connection.on(userId, (item) => {
    //             console.log('item', item)
    //             let notification = {'count' : item.isCustomerViewedCount, 'list' : item.bookingList};
    //             dispatch(setCustomerNotification(notification));
    //         });
        
    //         connectionRef.current = connection; // Store connection in ref
        
    //         return () => {
    //             connection.stop();
    //         };
    //     }
    // }, []);

    // useEffect(() => {
    //     if (loggedUser?.id) {
    //         requestNotificationPermission(dispatch, webNotificationStatus);

    //         const userId = "CustomerPushNotification" + loggedUser.id;

    //         initCustomerConnection(userId, (item) => {
    //             if (item.length > 0) {
    //                 const booking = item[0].bookingList[0];
    //                 const notificationTitle = booking.serviceName;
    //                 const notificationBody = `${booking.notificationType} on ${moment(booking.slotDateTime).format("MM-DD-YYYY HH:mm")}`;
                    
    //                 showNotification(notificationTitle, { body: notificationBody });
    //             }
    //         });
    //     }
    // }, [loggedUser?.id]);

    // useEffect(() => {
    //     if ( loggedUser && loggedUser.id ) {
    //         requestNotificationPermission(dispatch, webNotificationStatus);

    //         let userId = 'CustomerPushNotification'+loggedUser.id;
    //         const connection = new signalR.HubConnectionBuilder()
    //             .withUrl("https://unextdev.datanetiix.com/customerPushNotificationHub")
    //             .withAutomaticReconnect()
    //             .build();
        
    //         connection
    //             .start()
    //             .then()
    //             .catch((err) => console.error("test eerr:", err));
        
    //         connection.on(userId, (item) => {
    //             console.log('item', item)
    //             if ( item.length > 0 ) {
    //                 console.log('list', item[0].bookingList[0])
    //                 const notificationTitle = item[0].bookingList[0].serviceName;
    //                 const notificationBody = `${item[0].bookingList[0].notificationType} on ${moment(item[0].bookingList[0].slotDateTime).format("MM-DD-YYYY HH:mm")}`;
                    
    //                 showNotification(notificationTitle, { body: notificationBody });
    //             }
    //         });
        
    //         connectionRef.current = connection; // Store connection in ref
        
    //         return () => {
    //             connection.stop();
    //         };
    //     }
    // }, []);

    const doLogout = (popupState)=>{
        popupState.close();
        Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to Log Out?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Log Out!'
        }).then((result) => {
            if (result.isConfirmed) {
                if(props.getBack){
                    props.getBack(true);
                }
                dispatch(setCustomerLogoutUrl(urlPathName));
                dispatch(setCustomerLogout());
                if(urlPathName === '/customer/settings' || urlPathName === '/customer/bookinghistory'){
                    navigate("/customerlogin");
                }else{
                    navigate("/customer/home");
                }
            }
        })   
    }
    const navigator = (nivigation) => {
        navigate(nivigation);
    }

    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => window.removeEventListener('scroll', stickNavbar);
    }, []);

    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            windowHeight > 60 ? setStickyClass('sticky-nav') : setStickyClass('');
        }
    };

    const [stickyClass, setStickyClass] = useState('');

    // const notificationOpen = () => {
    //     postCustomerNotificationView().then(res => notificationViewResponseHandle(res));
    // }

    // const notificationViewResponseHandle = ( res ) => {
    //     let notification = {'count' : 0, 'list' : customerNotification.list};
    //     dispatch(setCustomerNotification(notification));
    // }

    return(
        <div  className={`custom-header ${stickyClass}`}>
            <Navbar expand="md" >
                <Container >
                    <Navbar.Brand>
                    <Link to="../customer"><Image src={logo} /></Link> 
                    </Navbar.Brand>
                    {
                        loggedUser !== null && apiToken != '' ? 
                            <div className='pro-mobile-view '>
                                <Stack direction="horizontal" className="align-items-end" gap={2}>
                                    {/* <PopupState variant="popover" popupId="demo-popup-popover">
                                        {(popupState) => {
                                            const handleNotificationClick = (event) => {
                                                notificationOpen();

                                                if (!popupState.isOpen) {
                                                    popupState.open(event);
                                                }
                                            };

                                            return (
                                                <div>
                                                    <Button
                                                        variant=""
                                                        {...bindTrigger(popupState)}
                                                        className="notoficationBtn"
                                                        onClick={handleNotificationClick}
                                                    >
                                                        <Image src={notify} />
                                                        {customerNotification && customerNotification.count !== undefined && customerNotification.count !== 0 && (
                                                            <p className="count">{customerNotification.count}</p>
                                                        )}
                                                    </Button>

                                                    <Popover
                                                        {...bindPopover(popupState)}
                                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                    >
                                                        <Typography sx={{ p: 2 }}>
                                                            <h3>Notifications</h3>
                                                            <hr />
                                                            {customerNotification && customerNotification.list !== undefined && customerNotification.list.length > 0 ? (
                                                                customerNotification.list.map((item, index) => (
                                                                    <div
                                                                        className="notification-row"
                                                                        key={index}
                                                                    >
                                                                        <div className="notification-img-row">
                                                                            <div className="circle"></div>
                                                                            <div className="profile">
                                                                                <Image src={person} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="content">
                                                                            <h5>{item.serviceName}</h5>
                                                                            <p>{item.notificationType}<br></br> on {moment(item.slotDateTime).format("MM-DD-YYYY HH:mm")}</p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <p>No new notifications</p>
                                                            )}
                                                        </Typography>
                                                    </Popover>
                                                </div>
                                            );
                                        }}
                                    </PopupState> */}
                                    <PopupState variant="popover" popupId="demo-popup-popover" >
                                        {(popupState) => (
                                            <div>
                                                    <Button variant="" {...bindTrigger(popupState)}>
                                                        <div className="pro-sec">
                                                        <div className="top-profile">
                                                            <Image src={person} />
                                                        </div>
                                                        </div>
                                                    </Button>

                                                    <Popover
                                                        {...bindPopover(popupState)}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'center',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'center',
                                                        }}
                                                        >
                                                        <Typography sx={{ p: 2 }}> 
                                                            <Row className="profile-dropdown">
                                                                <Col><Image src={person} />
                                                                <h4>{loggedUser ? loggedUser.firstName+' '+loggedUser.lastName : ''}</h4>
                                                                <h6>{loggedUser ? loggedUser.email : ''}</h6>
                                                                </Col>
                                                            </Row> 
                                                            <hr/>
                                                            <Row className="profile-link">
                                                                <Col>
                                                                <div className="text-center"><a onClick={() => doLogout(popupState)} style={{textAlign:'center'}}>Log Out</a></div>
                                                                
                                                            </Col>
                                                            </Row>
                                                            
                                                        </Typography>
                                                    </Popover>
                                            </div>
                                        )}
                                    </PopupState>
                                </Stack>
                            </div>
                        : ''
                    }
                    

                    
                    <Navbar.Toggle aria-controls="offcanvasNavbar-expand-md" onClick={handleShow} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-md`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-md`}
                        placement="end"
                        show={show} 
                        onHide={handleClose}
                        className="customerOffcanvas"
                    >
                        
                        <Offcanvas.Header>
                            <button onClick={handleClose}><CloseIcon /></button>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                                <Link to="../customer"><Image src={logo} /></Link>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>


                            <Nav className="justify-content-center flex-grow-1 align-items-center menu-body">
                                {
                                    loggedUser === null || apiToken === '' ?
                                        ''
                                    :
                                        <Link to="../stylistlogin" className="professionLoginBtm" target="_blank" >Pro Login</Link>
                                }

                                {
                                    loggedUser !== null && apiToken != '' ?
                                        <>
                                            <Link to="../customer/home" ><HomeIcon /> HOME</Link>
                                            <Link to="../stylistlogin" className="professionLogin" target="_blank" ><PersonAddIcon />PRO LOGIN</Link>
                                            <Link to="../mission" ><Diversity2Icon /> MISSION</Link>
                                            <Link to="../customer/bookinghistory" ><EventAvailableIcon /> APPOINTMENTS</Link>
                                            <Link to="../customer/settings" ><AppSettingsAltIcon /> SETTINGS</Link>
                                        </>
                                    : 
                                        <>
                                            <Link to="../customer/home" ><HomeIcon /> HOME</Link>
                                            {/* <Link to="../stylistlogin" target="_blank" className="professionLogin"><PersonAddIcon />PRO LOGIN</Link> */}
                                            <Link to="../mission" ><Diversity2Icon /> MISSION</Link>
                                        </>
                                }
                            </Nav>
                            
                            <div className='sign-up' style={{display: 'flex'}}>
                                {
                                    loggedUser === null || apiToken === '' ?
                                        <>
                                            <NavDropdown title={<span><LoginIcon /> LOGIN</span>} id="basic-nav-dropdown">
                                                <NavDropdown.Item as={Link} to="/customerlogin">Customer Login</NavDropdown.Item>
                                                <NavDropdown.Item as={Link} to="/stylistlogin" target="_blank">Pro Login</NavDropdown.Item>
                                            </NavDropdown>
                                            <NavDropdown title={<span><LockOpenIcon /> SIGN UP</span>} id="basic-nav-dropdown" className='SignUpDrapdown'>
                                                <NavDropdown.Item as={Link} to="/customercreateanaccount">Customer Sign Up</NavDropdown.Item>
                                                <NavDropdown.Item as={Link} to="/stylistregistration" target="_blank">Pro Sign Up</NavDropdown.Item>
                                            </NavDropdown>
                                            {/* <Link to="/customerlogin" ><LoginIcon /> LOGIN </Link>  */}
                                            {/* <Link to="/customercreateanaccount" ><LockOpenIcon /> SIGN UP</Link>  */}
                                            
                                        </>
                                    :
                                        <div className='hide-mobile'>
                                            <Stack direction="horizontal" className="align-items-end" gap={2}>
                                                {/* <PopupState variant="popover" popupId="demo-popup-popover">
                                                    {(popupState) => {
                                                        const handleNotificationClick = (event) => {
                                                            notificationOpen();

                                                            if (!popupState.isOpen) {
                                                                popupState.open(event);
                                                            }
                                                        };

                                                        return (
                                                            <div>
                                                                <Button
                                                                    variant=""
                                                                    {...bindTrigger(popupState)}
                                                                    className="notoficationBtn"
                                                                    onClick={handleNotificationClick}
                                                                >
                                                                    <Image src={notify} />
                                                                    {customerNotification && customerNotification.count !== undefined && customerNotification.count !== 0 && (
                                                                        <p className="count">{customerNotification.count}</p>
                                                                    )}
                                                                </Button>

                                                                <Popover
                                                                    {...bindPopover(popupState)}
                                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                                >
                                                                    <Typography sx={{ p: 2 }}>
                                                                        <h3>Notifications</h3>
                                                                        <hr />
                                                                        {customerNotification && customerNotification.list !== undefined && customerNotification.list.length > 0 ? (
                                                                            customerNotification.list.map((item, index) => (
                                                                                <div
                                                                                    className="notification-row"
                                                                                    key={index}
                                                                                >
                                                                                    <div className="notification-img-row">
                                                                                        <div className="circle"></div>
                                                                                        <div className="profile">
                                                                                            <Image src={person} />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="content">
                                                                                        <h5>{item.serviceName}</h5>
                                                                                        <p>{item.notificationType}<br></br> on {moment(item.slotDateTime).format("MM-DD-YYYY HH:mm")}</p>
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p>No new notifications</p>
                                                                        )}
                                                                    </Typography>
                                                                </Popover>
                                                            </div>
                                                        );
                                                    }}
                                                </PopupState> */}
                                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                                    {(popupState) => (
                                                        <div>
                                                            <Button variant="" {...bindTrigger(popupState)}>
                                                                <div className="pro-sec">
                                                                <div className="top-profile">
                                                                    <Image src={person} />
                                                                </div>
                                                                </div>
                                                            </Button>

                                                            <Popover
                                                                {...bindPopover(popupState)}
                                                                anchorOrigin={{
                                                                    vertical: 'bottom',
                                                                    horizontal: 'center',
                                                                }}
                                                                transformOrigin={{
                                                                    vertical: 'top',
                                                                    horizontal: 'center',
                                                                }}
                                                                >
                                                                <Typography sx={{ p: 2 }}> 
                                                                    <Row className="profile-dropdown">
                                                                        <Col><Image src={person} />
                                                                        <h4>{loggedUser ? loggedUser.firstName+' '+loggedUser.lastName : ''}</h4>
                                                                        <h6>{loggedUser ? loggedUser.email : ''}</h6>
                                                                        </Col>
                                                                    </Row> 
                                                                    <hr/>
                                                                    <Row className="profile-link">
                                                                        <Col>
                                                                        <div className="text-center"><a onClick={() => doLogout(popupState)} style={{textAlign:'center'}}>Log Out</a></div>
                                                                    </Col>
                                                                    </Row>
                                                                    
                                                                </Typography>
                                                            </Popover>
                                                        </div>
                                                    )}
                                                </PopupState>
                                            </Stack>
                                        </div>
                                }
                            </div>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
        </div>
    )
}